<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import Vue from "vue";
import "vue-select/dist/vue-select.css";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
Vue.component("v-select", vSelect);
/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader},
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalArticulos: 0,
        total: "",
        state: true,
        id: 0,
        totalPendiente:0,
        totalPagado:0
      },
      no_venta:0,
      reporteya:false,
      cliente:null,
      arraycliente: [],
      arrayclientes: [],
      estadoCredito:null,
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.usuariosL();
  },
  updated() {
  },
  methods: {
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    generar(){
    this.reporteya=true;
    this.detalle();
    },
    resetV(){
        this.reporteya=false;
        this.cliente=null;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      let id=me.cliente?me.cliente.id:'';
      axios
          .get(
              process.env.VUE_APP_URL +
              "reportes/reporteClientes?search="+ id, 
              {
                headers: {"x-token": me.userT.token},
              }
          )
          .then((response) => {
            let detalleProducto = response.data.rows;
            me.detalleorden=detalleProducto
            me.formPro.totalArticulos =  response.data.count;
          });
    },
    async selectcliente(valor) {
      this.arraycliente = [];
      for (var i = 0; i < this.arrayclientes.length; i++) {
        const estado = this.arrayclientes[i].nombre
            .toLowerCase()
            .includes(valor.toLowerCase());
        if (estado === true) {
          this.arraycliente.push(this.arrayclientes[i]);
        } else {
          // console.log("nada")
        }
      }
    },
    async usuariosL() {
        this.arrayclientes = [];
      try {
        const response = await axios.get(
            process.env.VUE_APP_URL + "clientes/busqueda",
            {
              headers: {"x-token": this.userT.token},
            }
        );
        this.arrayclientes = response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>

</style>
<template>
  <Layout v-if="reporteya==true">
    <PageHeader :title="title" :items="items" class="d-print-none"/>
    <div class="row mt-4">
      <div class="col d-print-none">
        <b-button
                @click="resetV"
                class="ms-1"
                ><i  class="mdi mdi-arrow-left me-1"></i>REGRESAR</b-button
              >
      </div>
      <div class="col d-print-none">
        <div class="float-end">
          <a
              ref="buttonImprimir"
              href="javascript:window.print()"
              class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a
          >
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark">
          <!-- <div class="row">
            <div class="col"></div>
            <div class="col">
              <img
                class="img-fluid float-right"
                src="../../../../../src/assets/images/logoZonaR.png"
                alt="Logo"
              />
            </div>
          </div> -->
          <div class="card-body">
            <!-- <div class="invoice-title">
              <h4 class="float-end font-size-14">
                Cotización# {{ this.formPro.no_orden }}
              </h4>
            </div> -->
            <div class="row">
                <div class="col-3"></div>
                <div class="col-6">
              <img
                  class="img-fluid float-right grises"
                  src="../../../../../src/assets/images/logoZonaR.png"
                  alt="Logo"
              />
            </div>
        </div>
            <br/>
            <div class="row" align="center">
              <div class="col" align="center">
                <h2 style="font-weight: bold;">Datos Clientes</h2>
              </div>
            </div>
            <div class="row" align="center">
              <div class="col" align="left">
                <h5>Cantidad de clientes</h5>
              </div>
              <div class="col" align="left">
                <h5>{{ formPro.totalArticulos }}</h5> 
              </div>
              <div class="col" align="left">
               <h5>{{ showHour(new Date()) }} </h5>
              </div>
            </div>
            <div>
              <table class="table table-sm table-bordered table-striped">
               
                <tr style=" padding: 0 !important; margin: 0 !important;">
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">CUI</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;">
                    <h5 style="font-weight: bold;">NIT</h5>
                  </th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">NOMBRE</h5></th>
                  <th style=" padding: 0 !important; margin: 0 !important;">
                    <h5 style="font-weight: bold;">TELEFONO</h5>
                  </th>
                  <th style=" padding: 0 !important; margin: 0 !important;"><h5 style="font-weight: bold;">DIRECCION</h5></th>
                  
                </tr>
              
                <tbody>
                <tr v-for="(item, idx) in detalleorden" v-bind:key="idx" style=" padding: 0 !important; margin: 0 !important;">
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.persona.cui_persona }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.nit_cliente }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.persona.nombre_persona }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.persona.telefono_persona }}
                    </h6>
                  </td>
                  <td style=" padding: 0 !important; margin: 0 !important;">
                    <h6>
                      {{ item.persona.direccion_persona }}
                    </h6>
                  </td>
                 
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  <Layout v-else>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="watermark"> 
          <div class="card-body">
            <br/>
            <div class="row" align="center">
              <div class="col" align="left">
                <h2>Datos Clientes</h2>
              </div>
            </div>
            <div  class="row" align="center">
                <div class="col" align="left">
                    <form>
            <!-- Descripcion -->
            <div class="col-6">
                <div class="row">
                <label for="phone">Seleccione un usuario</label>
                </div>
                <div class="row">
                    <div class="col">
                    <v-select
                    style="--vs-dropdown-max-height: 200px;"
                                  v-model.trim="cliente"
                                  :options="arraycliente"
                                  @search="selectcliente"
                                  placeholder="Buscar cliente..."
                                  label="nombre"
                              >
                              <template v-slot:option="options">
                              {{
                                options.persona.nombre_persona 
                              }}
                            </template>
                            <template
                              slot="selected-option"
                              slot-scope="option"
                            >
                              {{
                                option.persona.nombre_persona 
                              }}
                            </template>
                              </v-select>
                            </div>
                </div>      
            </div>
            <!-- Botones -->
            <div class="text-end pt-5 mt-3">
              <b-button
                @click="generar"
                variant="success"
                class="ms-1"
                >Generar Reporte</b-button
              >
            </div>
          </form>    
            </div>
        </div>
        </div>
    </div>
    </div>
    </div>
  </Layout>
</template>
<style>
.grises {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}
</style>
